<div class="responsive-dropdown-scaffold" #dropdown (click)="onDropdownClick()" (blur)="onBlur()" [attr.aria-owns]="panelOpen ? itemIds : null" role="listbox" [tabindex]="disabled ? '-1' : null">
  <ng-content select="[dropdown]"></ng-content>
</div>

<ng-template #dropdownPortal>
  <div class="dropdown-portal" [ngStyle]="{ 'min-width': minWidth != null ? (minWidth + 'px') : null }">
    <div *ngIf="title != null && title !== ''" class="menu-heading">
      <span class="text-truncate">{{title}}</span>
    </div>
    <div class="menu-items">
      <ng-content select="[dropdown-content]"></ng-content>
    </div>
  </div>
</ng-template>
